module.exports = __webpack_public_path__ + "static/step1-7769eff9c512d2ef381fa5c69664da0b.svg";